import { render } from "./NavigationBtn.vue?vue&type=template&id=7d4aa2b5&scoped=true&ts=true&lang=pug"
import script from "./NavigationBtn.vue?vue&type=script&lang=ts"
export * from "./NavigationBtn.vue?vue&type=script&lang=ts"

import "./NavigationBtn.vue?vue&type=style&index=0&id=7d4aa2b5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4aa2b5"]])

export default __exports__